import { useCallback } from 'react'
import { useAuthStore } from '@/store/authStore'
import { useTenantStore } from '@/store/tenantStore'
import { EMPTY_GRADING_DRAFT, useGradingDraftStore, type GradingDraft } from '@/store/gradingDraftStore'

// Entity IDs identify the learner and attempt as well as the sheet.
export const gradingDraftScope = {
  pause: (componentProgressId: number) => `pause:${componentProgressId}`,
  test: (testId: number) => `test:${testId}`,
  reviewNote: (setId: number) => `review-note:${setId}`,
  unitAssessment: (learnerId: number, assessmentId: number) => `unit-assessment:${learnerId}:${assessmentId}`,
}

function scopedKey(tenantId: string | null, userId: number | null, scope: string) {
  return JSON.stringify([tenantId, userId, scope])
}

export function useGradingDraft(scope: string) {
  const tenantId = useTenantStore((state) => state.tenantId)
  const userId = useAuthStore((state) => state.user?.id ?? null)
  const key = scopedKey(tenantId, userId, scope)
  const draft = useGradingDraftStore((state) => state.drafts[key] ?? EMPTY_GRADING_DRAFT)
  const update = useGradingDraftStore((state) => state.update)
  const setDraft = useCallback((updater: (draft: GradingDraft) => GradingDraft) => {
    update(key, updater)
  }, [key, update])
  const clearRow = useCallback((quizId: string) => {
    useGradingDraftStore.getState().clearRow(key, quizId)
  }, [key])
  return { draft, setDraft, clearRow }
}

export function useClearGradingDraftRow() {
  const tenantId = useTenantStore((state) => state.tenantId)
  const userId = useAuthStore((state) => state.user?.id ?? null)
  return useCallback((scope: string, quizId: string) => {
    useGradingDraftStore.getState().clearRow(scopedKey(tenantId, userId, scope), quizId)
  }, [tenantId, userId])
}
